import router from './router'
import i18n from '@/modules/Core/plugins/i18n'
import MainModule from '@/modules/Core'
import BranchModule from '@/modules/Branch'
import AuthModule from '@/modules/Auth'
import PersonnelModule from '@/modules/Personnel'
import LawyerModule from '@/modules/Lawyer'
import HelpRecipientModule from '@/modules/HelpRecipient'
import FinancialContractModule from '@/modules/FinancialContract'
import NonFinancialContractModule from '@/modules/NonFinancialContract'
import RegistrationModule from '@/modules/Registration'
import ClaimModule from '@/modules/Claim'
import EstateContractsModule from '@/modules/EstateContracts'

function flattenModules(modules: Modules): Array<[string, Module]> {
  const entries: Array<[string, Module]> = []

  Object.keys(modules).forEach((moduleKey) => {
    const qualifiedKey = moduleKey
    const module = modules[moduleKey]
    entries.push([qualifiedKey, module])

    if (module.subModules) {
      entries.push(...flattenModules(module.subModules))
    }
  })

  return entries
}

export function registerModules(modules: Modules) {
  const flatModules = flattenModules(modules)

  flatModules.forEach(([moduleKey, module]) => {
    if (module.localization) {
      for (const locale in module.localization) {
        i18n.global.mergeLocaleMessage(
          locale,
          moduleKey === 'main'
            ? module.localization[locale]
            : {
                [moduleKey]: module.localization[locale],
              }
        )
      }
    }

    if (module.router) {
      module.router(router)
    }
  })
}

registerModules({
  branch: BranchModule,
  main: MainModule,
  auth: AuthModule,
  personnel: PersonnelModule,
  lawyer: LawyerModule,
  helpRecipient: HelpRecipientModule,
  financialContract: FinancialContractModule,
  nonFinancialContract: NonFinancialContractModule,
  registration: RegistrationModule,
  claim: ClaimModule,
  estateContracts: EstateContractsModule,
})
